import cn from 'classnames'
import React, { ComponentProps } from 'react'
import { useTranslate } from 'src/localization/Trns'

type MccBusinessIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function MccBusinessIcon(props: MccBusinessIconProps) {
  const translate = useTranslate()
  const { className = '', ['aria-label']: ariaLabel, ...rest } = props
  return (
    <svg
      className={cn('MccBusinessIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={ariaLabel ?? translate('Business')}
      {...rest}
    >
      <path
        d="M8.66665 6.33333H11.8666C12.6134 6.33333 12.9868 6.33333 13.272 6.47866C13.5229 6.60649 13.7268 6.81046 13.8547 7.06135C14 7.34656 14 7.71993 14 8.46667V13M8.66665 13V3.13333C8.66665 2.3866 8.66665 2.01323 8.52132 1.72801C8.39349 1.47713 8.18952 1.27316 7.93863 1.14532C7.65342 1 7.28005 1 6.53331 1H4.13331C3.38658 1 3.01321 1 2.72799 1.14532C2.47711 1.27316 2.27314 1.47713 2.1453 1.72801C1.99998 2.01323 1.99998 2.3866 1.99998 3.13333V13M14.6666 13H1.33331M4.33331 3.66667H6.33331M4.33331 6.33333H6.33331M4.33331 9H6.33331"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
